export class ReportType {
  code: string;
  type: string;
  provider: string;
  name: string;
  icon?: string;
  description?: string;
  area: string;
  permissions?: string[];
  filters: string[];
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/report-type.ts